import { useEffect, useRef } from 'react';
/**
 * @param {(state: boolean) => void} onClickOutside
 * @returns {React.MutableRefObject<HTMLElement>}
 */

export function useClickOutside(onClickOutside) {
  /**
   * @type {React.MutableRefObject<HTMLElement>}
   */
  var root = useRef(null);
  useEffect(function () {
    /**
     * @param {import('react').SyntheticEvent} event
     * @returns void
     */
    var listener = function listener(event) {
      if (!root.current) return;
      if (root.current.contains(event.target)) return;
      onClickOutside(false);
    };

    document.addEventListener('click', listener);
    return function () {
      document.removeEventListener('click', listener);
    };
  }, [onClickOutside]);
  return root;
}